import API from 'api'

export function getInit() {
  return API(``, true).get()
}
